import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../Auth/Context/AuthContext";
import { Table } from "antd";
import callApi from "../../helpers/callApi";
import TitleHeader from "../accounts/Components/TitleHeader";
function AuditLogs(props) {
  const { user } = useContext(AuthContext);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  let pageSizeValue = 20;
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: pageSizeValue,
      showSizeChanger: true,
      pageSizeOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
    },
  });
  let paging = { current: 1 };
  const handleTableChange = async (pagination, filter, sorter) => {
    pageSizeValue = pagination.pageSize;
    setTableParams({ pagination, filter, ...sorter });
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setLogs([]);
    }
    const params = { size: pagination.pageSize };
    paging.current = pagination.current;
    await fetchData(params);
  };

  async function fetchData(params = {}) {
    setLoading(true);
    let endpoint = `audit-logs/?branchId=${user?.branchId}`;
    const params1 = {
      ...params,
      page: paging.current - 1 || 0,
      size: pageSizeValue || null,
    };
    try {
      const response = await callApi(endpoint, null, null, params1);
      if (response.data && response.status === 200) {
        setLogs(response.data);
        const totalStudents = response.headers.get("x-total-count");
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: totalStudents,
            current: params1.page + 1,
            pageSize: pageSizeValue,
          },
        });
      } else {
        console.log("Logs error");
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);
  const columns = [
    {
      title: "Sno",
      dataIndex: "sno",
      responsive: ["sm"],
    },
    {
      title: "Username",
      dataIndex: "username",
      responsive: ["sm"],
    },
    {
      title: "Activity",
      dataIndex: "activity",
      responsive: ["sm"],
    },
    {
      title: "Date",
      dataIndex: "date",
      width: "20%",
      responsive: ["sm"],
    },
    {
      title: "Entity",
      dataIndex: "entity",
      width: "20%",
      responsive: ["sm"],
    },
    {
      title: "Transaction",
      dataIndex: "transaction",
      width: "20%",
      responsive: ["sm"],
    },
  ];
  return (
    <>
      <div class="page-wrapper">
        <div class="content container-fluid">
          <TitleHeader title={`Audit Logs-(${tableParams.pagination.total})`} />

          <div class="row">
            <div class="col-sm-12">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive">
                    <Table
                      size="small"
                      columns={columns}
                      pagination={tableParams.pagination}
                      onChange={handleTableChange}
                      loading={loading}
                      dataSource={logs?.map((item, index) => ({
                        key: item._id,
                        sno: index + 1,
                        activity: (
                          <p style={{ color: "#4682b4" }}>{item.activity}</p>
                        ),
                        username: <p>{item.username}</p>,
                        userEmail: item.result?.email,
                        date: (
                          <p style={{ color: "red" }}>{item.createdDate}</p>
                        ),
                        entity: item.entityName,
                        transaction: item.transactionName,
                      }))}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AuditLogs;
